import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import KineticHero from "@/components/KineticHero";
import SlowMarquee from "@/components/SlowMarquee";
import ManifestoChapters from "@/components/ManifestoChapters";
import InteractiveMenu from "@/components/InteractiveMenu";
import LocationSection from "@/components/LocationSection";
import SocialGrid from "@/components/SocialGrid";
import Footer from "@/components/Footer";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        let frame;
        const raf = (time) => {
            lenis.raf(time);
            frame = requestAnimationFrame(raf);
        };
        frame = requestAnimationFrame(raf);

        const onAnchor = (e) => {
            const link = e.target.closest('a[href^="#"]');
            if (!link) return;
            const target = document.querySelector(link.getAttribute("href"));
            if (target) {
                e.preventDefault();
                lenis.scrollTo(target, { offset: -72, duration: 1.4 });
            }
        };
        document.addEventListener("click", onAnchor);

        return () => {
            cancelAnimationFrame(frame);
            lenis.destroy();
            document.removeEventListener("click", onAnchor);
        };
    }, []);

    return (
        <div className="App noise" data-testid="app-container">
            <Navbar />
            <main>
                <KineticHero />
                <SlowMarquee />
                <ManifestoChapters />
                <InteractiveMenu />
                <LocationSection />
                <SocialGrid />
            </main>
            <Footer />
            <Toaster theme="dark" position="bottom-center" richColors />
        </div>
    );
}

export default App;
